// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__14RrF","info":"PatientInfo_info__IZ8Kk"};